import { z } from 'zod';

/** Empresa que a conta pode escolher como contexto. */
export const empresa = z.object({
  id: z.number().int().positive(),
  nome: z.string().min(1),
});
export type Empresa = z.infer<typeof empresa>;

/** Linha da tela de empresas, so para o admin geral. */
export const empresaAdmin = empresa.extend({
  cnpj: z.string().nullable(),
  is_active: z.boolean(),
  users_count: z.number().int().nonnegative(),
  banks_count: z.number().int().nonnegative(),
  user_ids: z.array(z.number().int().positive()),
});
export type EmpresaAdmin = z.infer<typeof empresaAdmin>;

export const empresaBody = z.object({
  nome: z.string().trim().min(1, 'Nome da empresa e obrigatorio.').max(128),
  cnpj: z
    .string()
    .trim()
    .max(18)
    .nullable()
    .optional()
    .transform((v) => (v ? v : null)),
});

export const empresaUpdateBody = empresaBody.extend({ is_active: z.boolean() });

/** Quem acessa a empresa. Substitui a lista inteira. */
export const empresaUsuariosBody = z.object({
  user_ids: z.array(z.number().int().positive()),
});

export const trocarEmpresaBody = z.object({
  empresa_id: z.number().int().positive(),
});

/** Troca o banco de trabalho (o de lancamento) dentro da empresa ativa. */
export const trocarBancoBody = z.object({
  bank_id: z.number().int().positive(),
});
